import { render, staticRenderFns } from "./EbEtiquette.vue?vue&type=template&id=0bc3361d&scoped=true"
import script from "./EbEtiquette.vue?vue&type=script&lang=js"
export * from "./EbEtiquette.vue?vue&type=script&lang=js"
import style0 from "./EbEtiquette.vue?vue&type=style&index=0&id=0bc3361d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3361d",
  null
  
)

export default component.exports